import React from 'react';
import CopyBox from './copyBox'
import working from './img/working.png'
import download from './img/file-download-line.png'

class Documents extends React.Component {

    constructor(props) {
        super(props)
        this.state = { waiting:false }
    }


    render() {
        console.log(this.props.devis.documents)
        return <React.Fragment>
                    {this.props.devis.documents.map(doc =>
                    <a className="document_download" key={doc.name} href={this.props.api.downloadDocument( this.props.devis._id.$oid, doc.name )} target="_blank">
                          <img src={download}/> {doc.name}
                    </a>)}
        </React.Fragment>
    }
}

export default Documents;